export default __webpack_public_path__ + "static/media/maps_32dp.d2ae6ef9.ico";